export default __webpack_public_path__ + "static/media/feedback.b4bb8e56.png";